import mapboxgl from "mapbox-gl";

const prettyDescription = (data) => {
    let result = '<div><table>';
    for (const [key, value] of Object.entries(data)) {
        if (key !== 'uuid') {
            result += `<tr><th id="key">${key[0].toUpperCase()}${key.slice(1)}:</th><th id="value">${value}</th></tr>`
        }
    }
    result += '</table></div>';
    return result;
}

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
  
    return div.firstChild;
}

const popupEnhancedDataValue = (map, data) => {
    const props = { ...data.properties };
    if (props.type === 'SpeedLimit') {
        props.dataType = data.geometry.type === 'Point' ? 'sign' : 'road';
    }

    new mapboxgl.Popup().setLngLat(data.lngLat)
        .setDOMContent(createElementFromHTML(prettyDescription(props)))
        .addTo(map);
}

const handlers = [
    { 'layer_ids': ['EnhancedData/Points', 'EnhancedData/Edges'], event: 'click', cb: popupEnhancedDataValue }
];

export default handlers;